export const isEmptyString = (value: string): boolean => !value?.trim()?.length;

export const isEmptyObject = (object: object): boolean => !Object.keys(object).length;
